import {
  AbsoluteCenter,
  Button as ChakraButton,
  Span,
  Spinner,
} from "@chakra-ui/react";
import { forwardRef } from "react";
import { useThemeConfig } from "../../hooks/useThemeConfig";

/**
 * @typedef {object} AdditionalButtonProps
 * @prop {boolean} [loading]
 * @prop {boolean} [disabled]
 * @prop {string} [loadingText]
 * @prop {React.ReactNode} children
 */

/**
 * @typedef {Omit<import("@chakra-ui/react").ButtonProps, "children" | "onChange"> & AdditionalButtonProps} ButtonProps
 */
export const Button = forwardRef(
  /**
   * @param {ButtonProps} props
   */
  function Button(props, ref) {
    const { loading, disabled, loadingText, children, ...rest } = props;

    const { buttonProps } = useThemeConfig();

    return (
      <ChakraButton
        {...buttonProps}
        disabled={loading || disabled}
        ref={ref}
        {...rest}
      >
        {loading && !loadingText ? (
          <>
            <AbsoluteCenter display="inline-flex">
              <Spinner size="inherit" color="inherit" />
            </AbsoluteCenter>

            <Span opacity={0}>{children}</Span>
          </>
        ) : loading && loadingText ? (
          <>
            <Spinner size="inherit" color="inherit" />

            {loadingText}
          </>
        ) : (
          children
        )}
      </ChakraButton>
    );
  },
);
